import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Showtime } from '../models';

@Component({
  selector: 'app-compact-showtime-pill',
  standalone: true,
  imports: [CommonModule],
  template: `
    <a
      class="showtime-pill"
      *ngIf="showtime?.redirectUrl"
      [href]="showtime.redirectUrl"
      target="_blank"
      rel="noreferrer"
      [title]="title()"
    >
      <strong>{{ showtime.showTime }}</strong>
      <span *ngIf="showtime.screenType || showtime.format">{{ showtime.screenType || showtime.format }}</span>
    </a>
  `,
  styles: [
    `
      .showtime-pill {
        min-height: 34px;
        border: 1px solid rgba(88, 224, 255, 0.28);
        border-radius: 999px;
        padding: 7px 10px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        color: var(--accent-contrast);
        background: var(--cyan);
        box-shadow: 0 8px 18px rgba(88, 224, 255, 0.14);
        white-space: nowrap;
      }

      .showtime-pill strong {
        font-size: 14px;
        line-height: 1;
        font-weight: 950;
      }

      .showtime-pill span {
        max-width: 72px;
        overflow: hidden;
        text-overflow: ellipsis;
        color: var(--accent-contrast);
        font-size: 10px;
        line-height: 1;
        font-weight: 900;
        opacity: 0.82;
      }

      @media (max-width: 640px) {
        .showtime-pill {
          min-height: 32px;
          padding: 7px 9px;
        }

        .showtime-pill strong {
          font-size: 13px;
        }

        .showtime-pill span {
          display: none;
        }
      }
    `,
  ],
})
export class CompactShowtimePillComponent {
  @Input({ required: true }) showtime!: Showtime;

  title(): string {
    const label = this.showtime.screenType || this.showtime.format;
    return label ? `${this.showtime.showTime} ${label}` : this.showtime.showTime;
  }
}
